import { render } from "./Owner.vue?vue&type=template&id=a045aef8&scoped=true"
import script from "./Owner.vue?vue&type=script&lang=js"
export * from "./Owner.vue?vue&type=script&lang=js"

import "./Owner.vue?vue&type=style&index=0&id=a045aef8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_typescript@5.4.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a045aef8"]])

export default __exports__